import * as React from "react";

function SvgForkless(props) {
  return (
    <svg viewBox="0 0 417.21 263.88" {...props}>
      <path fill="#fff" d="m301.55 34.35-9.4 5.4 9.4-5.4z" />
      <path
        fill="#b0f2dc"
        d="m249.83 66.66 12.4 7.26 15.6 9-.1.06 1.12.66 1.11.65.02.01 22.64 13.25.06-61.25-52.85 30.36zM246.21 194.92l-.04-61.27-.11.06-52.47 30.37-1.27.74V227.49l.01-.01 53.06-30.43.71-.41.03-.01.08-.05v-1.66zM189.84 166v-.01l-52.97 30.67-.88.51v62.67l52.98-30.4.91-.51-.01-1.56-.03-61.37z"
      />
      <path
        fill="#32cb87"
        d="M304.78 33.8a.85.85 0 0 0-.14-.19 1.41 1.41 0 0 0-.23-.18L248.1.89a1.14 1.14 0 0 0-1.13 0L190.8 33.33a1 1 0 0 0-.37.35L134.42 66l-.15.11a.5.5 0 0 0-.08.07 1.1 1.1 0 0 0-.29.5.13.13 0 0 1 0 .06 1.6 1.6 0 0 0 0 .23l.06 64.08-56.19 32.53-.12.09a.71.71 0 0 0-.2.2l-.09.12a.76.76 0 0 0-.06.16.37.37 0 0 0 0 .11 1.35 1.35 0 0 0 0 .29l.33 64.67a1.13 1.13 0 0 0 .56 1l56.2 32.55a1.12 1.12 0 0 0 1.12 0l55.76-32 .38-.22a1.33 1.33 0 0 0 .19-.14l1.64-.94 52.7-30.23 1.12-.64.67-.39a1 1 0 0 0 .33-.31l-.3-.17-.68-.4h-.05v-8.98l.1-16.62.23-38.82v-.62a1.06 1.06 0 0 1-.22-.65 1 1 0 0 1 0-.25 1.3 1.3 0 0 1 .17-.38 1.23 1.23 0 0 1 .25-.26.39.39 0 0 1 .1-.08L276.7 114l1.12-.65 1.13-.65L302.6 99a1.11 1.11 0 0 1 .48-.57l.41-.23.14-.08.12-.07 1.12-.65.06-63.06a1.07 1.07 0 0 0-.15-.54ZM279 112l-1.13.64-1.12.64-28 16-1.12.64-.34.19-.79-.46-53.18-31.06 52.82-30.46.55-.32a1.18 1.18 0 0 0 .57.15h.14l1 .57 12.72 7.34L276.7 85l1.12.65 1.13.66 22.26 13ZM136 259.84v-62.67l.87-.51 53-30.67V228.93l-.91.51ZM301.55 34.35l-9.39 5.4-44.56 25.61-8.91-5-13.2-7.45-3.89-2.26a1.31 1.31 0 0 1 .23-.24l-.32.18-27.91-16.28 53.93-31.14ZM136.1 68.94l53.58 30.14-53.53 31Zm55.14 93.91h-.2l-1-.58V162l-52.57-30.13L190 101.51l1.19-.69 1.05.6L245 131.7l-52.75 30.54ZM191 36l33.39 18.86 20.09 11.69L215.84 83l-24.76 14.29-13.34-7.51L137.25 67Zm-57.45 97.9.91-.52 54.24 30.68-52.59 30.44-1.25.73-1-.56-53.26-30.12Zm-54.08 32.59 54.27 30.69v62.65l-53.95-31.25Zm166.74 29.87v.22h-.09l-.71.41-53.06 30.43V164.82l1.27-.74 52.47-30.37.11-.06v61.27Zm3.62-129.7 52.85-30.36-.06 61.25Z"
      />
      <path
        fill="#fff"
        d="M413.84 99.48h-.01l-11.27 6.47 11.28-6.47zM277.82 150.25l.23-.14-.23-.13v.27zM248.35 194.87l.1-.06M248.35 196.66l.11.07v-.62l-.11.55zM248.29 196.5a.4.4 0 0 1 0 .15v-.46Z"
      />
      <path fill="#fff" d="M248.29 196.63a.4.4 0 0 0 0-.15Z" />
      <rect
        height={0.13}
        x={248.4}
        y={194.78}
        fill="#fff"
        transform="rotate(-71.57 248.379 194.838)"
      />
      <path fill="#fff" d="m302.81 164.53-.14.09v1.3l.22-.13v-1.22l-.08-.04z" />
      <path
        fill="#fff"
        d="m302.67 164.62.14-.09-.14-.09v.18zM248.67 132.99v.02l28.03 16.31v-.01l-28.03-16.32zM279.16 150.76l22.54 13.12.01-.01-22.54-13.12-.01.01z"
      />
      <path
        fill="#fff"
        d="m278.05 150.11 1.11.65.01-.01-1.11-.65-.01.01zM277.82 149.97l-1.12-.66v.01l1.12.66v-.01zM277.82 149.98l.23.13.01-.01-.24-.13v.01z"
      />
      <rect
        width={0.01}
        x={301.7}
        y={163.87}
        fill="#fff"
        transform="rotate(-30.12 301.747 163.892)"
      />
      <path
        fill="#fff"
        d="m301.7 163.88.97.56v-.01l-.96-.56-.01.01zM302.89 164.57v-.01l-.06-.04-.02.01.08.04z"
      />
      <path
        fill="#fff"
        d="m302.67 164.44.14.09.02-.01-.16-.09v.01zM330.5 146.56l26.14-14.93-26.14 14.93z"
      />
      <path
        fill="#d9dbda"
        d="m325.24 152.15-20.98 11.98-.18 62.85 53.96-31.15-.27-62.26-32.53 18.58zM360.26 132.15l-.24.14.26 62.24h.01l53.96-31.16.06-62.27-54.05 31.05z"
      />
      <path
        fill="#9a9a9a"
        d="M302.39 229.9h.07l-.13-.08ZM416 100.13l-.56.32-1.13.65-.06 62.27-54 31.16-.25-62.24.24-.14 48.5-27.87-48.5 27.87-.81.47a1 1 0 0 1-.3.11 1 1 0 0 1-.25 0 1.1 1.1 0 0 1-.57-.16l-.55-.32v1.28l-32.53 18.58 32.53-18.58.27 62.26-54 31.15.18-62.85-.57.32-.15.06a1.06 1.06 0 0 1-.19.06v.19l-.18 64V230a1.16 1.16 0 0 0 .34-.12l56.21-32.45L415.94 165a1.11 1.11 0 0 0 .56-1l.06-64.87a1.11 1.11 0 0 1-.56 1ZM414.31 101.1l-5.55 3.18 5.55-3.18z"
      />
      <path fill="#fff" d="m305.23 99.1 53.66 31.24.26-.14-53.39-31.4-.53.3z" />
      <path
        fill="#999"
        d="M416.41 98.59a.85.85 0 0 0-.14-.19 1 1 0 0 0-.23-.18l-56.31-32.53a1.14 1.14 0 0 0-1.13 0l-54.38 31.4-1.13.65-.12.07-.14.08-.4.24a1.09 1.09 0 0 0-.48.56l-23.66 13.66-1.12.65-1.12.65-28.78 16.61a.39.39 0 0 0-.1.08 1.15 1.15 0 0 0-.42.63 1.07 1.07 0 0 0 0 .25 1.11 1.11 0 0 0 .22.66v.61l-.23 38.82-.17 16.69v9h.05l.68.4.3.18.13.07 54.63 32.21.13.08.71.42v-1.56l.18-64v-.19a1.06 1.06 0 0 0 .19-.06l.15-.06.57-.32 21-12 32.53-18.58v-1.28l.55.32a1.1 1.1 0 0 0 .57.16 1 1 0 0 0 .25 0 1 1 0 0 0 .3-.11l.81-.47 55.18-31.7.56-.32a1.14 1.14 0 0 0 .37-1.6Zm-114.17 65.66Zm-.4 62.88-53.3-31.36.16-62.71L276.05 149l1.12.65.24.14 1.11.65 22.54 13.12.95.55Zm28.66-80.57-26.8 15.3-.55.32-.57-.34-1.12-.65-20.74-12.07-1.11-.65-1.11-.64-.21-.12-1.12-.66-1.12-.65-26-15.14 26-15 1.12-.65 1.12-.65 23.38-13.5 1.13-.65.44-.25.68.39 52.72 30.69Zm71.41-40.93-42.76 24.57-.26.14-53.66-31.24.53-.3L359.17 68l54 31.19Z"
      />
    </svg>
  );
}

export default SvgForkless;
